import axios from "axios";
import { warehouseId } from "../constants";
import { CheckerService_URL } from "../redux/Url";

const baseURL = `${CheckerService_URL}`;

const axiosInstance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
    WAREHOUSE_ID: warehouseId,
  },
});

const getTokenFromLocalStorage = () => {
  return localStorage.getItem("accessKey");
};

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getTokenFromLocalStorage();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401 || error.code === "ERR_NETWORK") {
      window.location = "/";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
